import controller from './four-o-four.controller';
import template from './four-o-four.pug';

const FourOFourComponent = {
  template,
  controller,
};

export default FourOFourComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/four-o-four/four-o-four.component.js